import Box from "@mui/material/Box";
import { usePathname } from "src/routes/hooks";

import Footer from "./footer";
import Header from "./header";

import { useWhiteLabel } from "src/context/WhiteLabelContext";
import PlacenetAuthentication from "src/components/placenet-authentication/placenet-authentication";
import { HEADER } from "../config-layout";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function MainLayout({ children }: Props) {
  const pathname = usePathname();

  // FS-2026-050/051: the directory hero meets the fixed header without a gap.
  const publicDirectoryPage = [
    "/sportproviders",
    "/sportmates",
    "/tournaments",
    "/sport-communities",
  ].includes(pathname.replace(/\/+$/, ""));
  const playerPage = pathname === "/player" || pathname.startsWith("/player/");
  const registrationPage =
    pathname === "/register" ||
    /^\/sportprovider\/[^/]+\/register\/?$/.test(pathname);
  const isLiveCalendar = window.location.href.includes("livecalendar");

  const whitelabelConfig = useWhiteLabel();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: whitelabelConfig.backgroundColor,
      }}
    >
      <PlacenetAuthentication />

      {!whitelabelConfig.hideHeader && !isLiveCalendar && <Header />}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 3,
          ...(publicDirectoryPage && {
            mt: 0,
            pt:
              !whitelabelConfig.hideHeader && !isLiveCalendar
                ? { xs: `${HEADER.H_MOBILE}px`, md: `${HEADER.H_DESKTOP}px` }
                : 0,
          }),
          ...((playerPage || registrationPage) && {
            mt: 0,
            pt:
              !whitelabelConfig.hideHeader && !isLiveCalendar
                ? {
                    xs: `${HEADER.H_MOBILE + 24}px`,
                    md: `${HEADER.H_DESKTOP + 40}px`,
                  }
                : { xs: 3, md: 5 },
            pb: { xs: 3, md: 5 },
          }),
        }}
      >
        {children}
      </Box>

      {!isLiveCalendar && !whitelabelConfig.hideFooter && <Footer />}
    </Box>
  );
}
